import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useCurrentEditor } from '@tiptap/react';

import { HighlightedKeywordContext } from '../../../pages/contentOptimizer/contentPage/content/optimizerTab/tiptapEditor/TipTapEditorWrapper';

import { selectSelectedKeyword } from '../../../pages/contentOptimizer/contentPage/store/contentOptimizerContent.selectors';
import { selectEditorHighlightKeywords } from '../store/tiptapEditor.selectors';

const HighlightSettings = () => {
    const { editor } = useCurrentEditor();

    const selectedKeyword = useSelector(selectSelectedKeyword);
    const isHighlightKeywordsOn = useSelector(selectEditorHighlightKeywords);

    const mappedKeywords = React.useContext(HighlightedKeywordContext) || [];

    useEffect(() => {
        const { mappedKeywords: storageKeywords } =
            editor?.storage.colorHighlighter || {};
        if (
            storageKeywords &&
            mappedKeywords.length !== storageKeywords.length
        ) {
            editor.commands.setKeywordList(mappedKeywords);
        }

        // eslint-disable-next-line
    }, [mappedKeywords?.length, editor]);

    useEffect(() => {
        if (editor?.storage.colorHighlighter) {
            editor.commands.setActiveKeyword(selectedKeyword);
        }
    }, [selectedKeyword, editor]);

    useEffect(() => {
        if (editor?.storage.colorHighlighter) {
            editor.commands.setHighlightingOn(isHighlightKeywordsOn);
        }
    }, [isHighlightKeywordsOn, editor]);

    return <></>;
};

export default HighlightSettings;
